import { useEffect } from 'react'
import i18n from './index'
import { isSupportedLocale, DEFAULT_LOCALE } from './index'
import { usePartner } from '../lib/usePartner'

// Hydrates i18next with the user's persisted locale once the partner profile
// loads. Falls back to DEFAULT_LOCALE when the user has no saved preference or
// the saved value is not in SUPPORTED_LOCALES (added locales we don't ship yet).
export function useLocaleSync() {
  const { data } = usePartner(true)
  const locale =
    data?.state === 'partner' ? (data.partner.user?.locale ?? null) : null

  useEffect(() => {
    const target = isSupportedLocale(locale) ? locale : DEFAULT_LOCALE
    if (i18n.language !== target) {
      void i18n.changeLanguage(target)
    }
    document.documentElement.lang = target
  }, [locale])
}
